/**
 * Typography used in theme
 * @param {JsonObject} theme theme customization object
 */

export default function themeTypography(theme) {
    return {
        fontFamily: theme?.customization?.fontFamily,
        h6: {
            fontWeight: 500,
            color: theme.heading,
            fontSize: '0.75rem'
        },
        h5: {
            fontSize: '0.875rem',
            color: theme.heading,
            fontWeight: 500
        },
        h4: {
            fontSize: '1rem',
            color: theme.heading,
            fontWeight: 600
        },
        h3: {
            fontSize: '1.25rem',
            color: theme.heading,
            fontWeight: 600
        },
        h2: {
            fontSize: '1.5rem',
            color: theme.heading,
            fontWeight: 700
        },
        h1: {
            fontSize: '2.125rem',
            color: theme.heading,
            fontWeight: 700
        },
        subtitle1: {
            fontSize: '0.875rem',
            fontWeight: 500,
            color: theme.subtitle
        },
        subtitle2: {
            fontSize: '0.75rem',
            fontWeight: 400,
            color: theme.subtitle
        },
        caption: {
            fontSize: '0.75rem',
            color: theme.caption,
            fontWeight: 400
        },
        body1: {
            fontSize: '1rem',
            fontWeight: 400,
            color: theme.body,
            lineHeight: '1.5rem'
        },
        body2: {
            fontSize: '1.2rem',
            fontWeight: 400,
            lineHeight: '1.5em',
            color: theme.body
        }
    };
}
